import './WebChatPluginPopup.scss';
import { ChatWithBotWidget } from './ChatWithBotWidget';
import React from 'react';

export function WebChatPluginPopup({
  conversation,
  webChatConfiguration,
  showResetButton,
  onResetClicked,
}) {
  const isMobile = window.innerWidth <= 768;

  const stopEventPropagation = React.useCallback(
    (e) => {
      if (isMobile) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    [isMobile]
  );

  const overlayClass = `prospera-web-chat-plugin-popup-overlay ${
    isMobile ? 'mobile' : ''
  }`;

  return (
    <>
      {isMobile ? (
        <div
          className={overlayClass}
          onClick={stopEventPropagation}
          onScroll={stopEventPropagation}
        />
      ) : null}
      <div className="prospera-web-chat-plugin-popup">
        <ChatWithBotWidget
          conversation={conversation}
          webChatConfiguration={webChatConfiguration}
          showResetButton={showResetButton}
          onResetClicked={onResetClicked}
          showInternalEvents={false}
          showBoundingBox={true}
        />
      </div>
    </>
  );
}
